import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    badge: {
      color: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Incidents'
  },
  {
    name: 'New Incident',
    url: '/incident/new-incident',
    iconComponent: { name: 'cil-library-add' }
  },
  {
    name: 'Manage Incidents',
    url: '/incident/manage-incident',
    linkProps: { fragment: 'someAnchor' },
    iconComponent: { name: 'cil-pencil' }
  },
  {
    name: 'Services',
    title: true
  },
  {
    name: 'Officer Services',
    url: '/services/officer',
    iconComponent: { name: 'cil-user' },
    children: [
      {
        name: 'New Officer',
        url: '/services/officer/new'
      },
      {
        name: 'Manage Officer',
        url: '/services/officer/manage'
      }
    ]
  },
  {
    name: 'Employee Services',
    url: '/services/employee',
    iconComponent: { name: 'cil-group' },
    children: [
      // {
      //   name: 'Search Employee',
      //   url: '/services/employee/search'
      // },
      {
        name: 'New Employee',
        url: '/services/employee/new'
      },
      {
        name: 'Manage Employees',
        url: '/services/employee/manage'
      }
    ]
  },
  {
    name: 'Contract Staff',
    url: '/services/staff',
    iconComponent: { name: 'cil-group' },
    children: [
      {
        name: 'New Staff',
        url: '/services/staff/new'
      },
      {
        name: 'Manage Staff',
        url: '/services/staff/manage'
      }
    ]
  },
  {
    name: 'Lost And Found',
    url: '/services/lostandfound',
    iconComponent: { name: 'cil-group' },
    children: [
      {
        name: 'New Entry',
        url: '/services/lostandfound/new-entry'
      },
      {
        name: 'Manage Form',
        url: '/services/lostandfound/manage-form'
      }
    ]
  },
  // {
  //   name: 'Gatepass Form',
  //   url: '/services/gatepass',
  //   iconComponent: { name: 'cil-group' },
  //   children: [
  //     {
  //       name: 'New Entry',
  //       url: '/services/gatepass/new-entry'
  //     },
  //     {
  //       name: 'Manage Gatepass',
  //       url: '/services/gatepass/manage-gatepass'
  //     }
  //   ]
  // },
  {
    name: 'Reports',
    title: true
  },
  {
    name: 'Incident Reports',
    url: '/report',
    iconComponent: { name: 'cil-description' },
    children: [
      {
        name: 'Graph Report',
        url: '/report/incident'
      },
    ]
  },
  {
    name: 'Security Reports',
    url: '/report',
    iconComponent: { name: 'cil-shield-alt' },
    children: [
      {
        name: 'Summary Report',
        url: '/report/sec-summary'
      },
    ]
  },
  {
    title: true,
    name: 'Masters',
  },
  {
    name: 'Categories',
    url: '/categories/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Departments',
    url: '/department/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Employer',
    url: '/employer/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Nationality',
    url: '/nationality/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Injury',
    url: '/injury/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Service',
    url: '/service/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Area',
    url: '/area/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'User',
    url: '/user/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Program',
    url: '/program/manage',
    iconComponent: { name: 'cil-settings' }
  },
  {
    name: 'Items',
    url: '/items/manage',
    iconComponent: { name: 'cil-settings' }
  },
  
];
